import { TopicState } from './interface';

const state: TopicState = {
  topicDetails: [],
  topicDetail: null,
  replyId: null,
};
export default state;
